import {
  stepContentClasses,
  Stepper as MuiStepper,
  styled,
} from '@mui/material';

export const Stepper = styled(MuiStepper)({
  [`& .${stepContentClasses.root}`]: {
    borderLeft: '1.6px solid grey',
    marginLeft: 16.5,
    paddingLeft: 48,
  },
});
